import { IUser } from "../components/AutoCompleteSearches/AutoCompleteSearches.types";
import { IContact } from "../redux/contacts/contacts.types";
import { ICustomer } from "../redux/customer";
import { IExpenseCategory } from "../redux/expenseModule";
import { IProduct } from "../redux/products/products.types";
import { IProject } from "../redux/projects/project.types";
import { IQuote } from "../redux/quote";
import { ITaskCategory } from "../redux/taskCategory/taskCategory.types";

type IRemoveDuplicateItems =
  | ICustomer
  | IContact
  | IProduct
  | IUser
  | IQuote
  | IProject
  | ITaskCategory
  | IExpenseCategory;

export const removeDuplicateItems = (
  options: IRemoveDuplicateItems[],
  key: string,
) => {
  // return options.filter((item, index) => options.indexOf(item) === index);
  //@ts-ignore
  return [...new Map(options.map((item) => [item[key], item])).values()];
};

export const removeDuplicateUsers = (options: IUser[]) => {
  return options.filter(
    (item, index) =>
      options.find((item2) => item2.user_uuid === item.user_uuid)?.user_uuid !==
      item.user_uuid,
  );
};
